import home from './cn/home'
import binocular from './cn/binocular'
import eight from './cn/eight'
import about from './cn/about'
import coreTech from './cn/coreTech'
import purchase from './cn/purchase'
import purchasetow from './cn/purchasetow'
import purchasezhijia from './cn/purchasezhijia'
import manage from './cn/manage'
import agent from './cn/agent'
import toast from './cn/toast'

export default {
  title: '中文',
  crumbs: [{
    id: 'pro',
    name: '四维看看 Pro'
  }, {
    id: 'lite',
    name: '四维看看 Lite'
  }],
  navs: {
    services: '服务与支持',
    application: '行业与应用',
    setting: {
      'purchase': [
        {
          icon: 'icon-icon_cam_pro',
          name: '四维看看 Pro<br/>&nbsp;',
          new: true,
          to: {name: 'purchase'}
        },
        {
          icon: 'icon-icon_cam_zengzhi',
          name: '云容量<br/>&nbsp;',
          to: {name: 'pricedetail'}
        },
        // {
        //   icon: 'icon-icon_cam_lite',
        //   name: '四维看看 Lite<br/>&nbsp;',
        //   to: {name: 'binocular'}
        // },
        {
          icon: 'icon-icon_cam_fitting',
          name: '四维看看 Pro三脚架套装',
          to: {name: 'purchasezhijia'}
        },
        {
          icon: 'icon-jingxiaoshang',
          name: '成为经销商<br/>&nbsp;',
          to: {name: 'agent'}
        }
      ],
      'service_overview': [
        {
          icon: 'icon-appdown',
          name: 'App下载',
          to: {name: 'service_list', params: {id: 'app', active: 'pro'}}
        },
        {
          icon: 'icon-tutorial',
          name: '使用教程',
          to: {name: 'service_list', params: {id: 'use', active: 'pro'}}
        },
        {
          icon: 'icon-faq',
          name: '常见问题',
          to: {name: 'service_list', params: {id: 'qa', active: 'pro'}}
        },
        // {
        //   icon: 'icon-sysc',
        //   name: '产品手册',
        //   to: {name: 'service_list', params: {id: 'product', active: 'all'}}
        // },
        {
          icon: 'icon-baoxiutiaokuan',
          name: '保修条款',
          to: {name: 'service_list', params: {id: 'clause', active: 'pro'}}
        },
        {
          icon: 'icon-teaching',
          name: '视频教程',
          to: {name: 'video-course'}
        }
      ],
      'case_overview': [
        {
          icon: 'icon-industry_realty',
          name: '房地产',
          to: {name: 'cases', params: {id: '房地产'}}
        }, {
          icon: 'icon-industry_museum',
          name: '博物馆',
          to: {name: 'cases', params: {id: '博物馆'}}
        },
        {
          icon: 'icon-industry_ecom',
          name: '电商',
          to: {name: 'cases', params: {id: '电商'}}
        },
        {
          icon: 'icon-industry_home',
          name: '家居',
          to: {name: 'cases', params: {id: '家居'}}
        },
        {
          icon: 'icon-industry_catering',
          name: '餐饮',
          to: {name: 'cases', params: {id: '餐饮'}}
        },
        {
          icon: 'icon-industry_industry',
          name: '其他',
          to: {name: 'cases', params: {id: '其他'}}
        },
        {
          icon: 'icon-industry_all',
          name: '全部',
          to: {name: 'cases', params: {id: '全部'}}
        }
      ]
    }
  },
  headers: {
    navs: [
      {text: '产品购买', cp: 'purchase'},
      {text: '行业应用', cp: 'case_overview'},
      {text: '服务支持', cp: 'service_overview'},
      {text: '核心技术', cp: 'location'},
      {text: '关于我们', cp: 'about'}
    ],
    login: '登录',
    cart: '购物车',
    myaccount: '我的账号',
    logout: '退出登录'
  },
  cases: {
    sceneSelected: {
      '筛选设备': '筛选设备',
      '全部': '全部',
      '四维看看 Lite': '四维看看 Lite',
      '四维看看 Pro': '四维看看 Pro'
    },
    selectType: [
      {
        id: '全部',
        name: '全部'
      },
      {
        id: '四维看看 Lite',
        name: '四维看看 Lite'
      },
      {
        id: '四维看看 Pro',
        name: '四维看看 Pro'
      }
    ],
    sort: {
      name: '排序',
      items: [
        {
          id: 1,
          name: '网站推荐'
        },
        {
          id: 2,
          name: '最新发布'
        },
        {
          id: 3,
          name: '热门浏览'
        }
      ]
    },
    typeName: {
      '房地产': '房地产',
      '博物馆': '博物馆',
      '家居': '家居',
      '餐饮': '餐饮',
      '其他': '其他',
      '电商': '电商',
      '全部': '全部'
    },
    typeArr: {
      '房地产': 2,
      '博物馆': 1,
      '家居': 5,
      '餐饮': 4,
      '其他': 0,
      '电商': 3,
      '全部': null
    }
  },
  search: {
    placeholder: '请输入关键字查找场景'
  },
  footer: {
    fdage: '四维时代',
    cgaii: '中德人工智能研究院',
    model: '四维模库',
    arr: [
      {
        key: '销售合作',
        val: 'sales@4dage.com'
      }, {
        key: '媒体采访',
        val: 'pr@4dage.com'
      }, {
        key: '联系电话',
        val: '400-669-8025'
      }
    ]
  },
  kefu: {
    wechat: '4DKanKan 微信公众号',
    arr: [
      {
        key: '销售合作',
        val: 'sales@4dage.com'
      }, {
        key: '媒体采访',
        val: 'pr@4dage.com'
      }, {
        key: '联系电话',
        val: '+86 400-6698-025'
      }, {
        key: '工作时间',
        val: '周一至周五 09:00 - 12:30, 14:00 - 18:30 (GMT+8)'
      }
    ]
  },
  chat: {
    title: '微信客服<br/><span style="font-size:14px">工作时间：周一至周五9:00-18:30</span>',
    p1: '请留下您的联系方式 （邮箱或电话号码）',
    p2: '请留下您的电话',
    p3: '请写下您的留言信息',
    send: '发送'
  },
  paypage: {
    name: '当前账号：',
    paycenter: '支付中心',
    method: '支付方式：',
    ali: '支付宝',
    wechatpay: '微信支付',
    amount: '应付金额：',
    use1: '使用',
    use2: 'app扫码完成支付'
  },
  _404: {
    txt: '抱歉，您访问的页面出现了错误，请重新加载',
    btn: '返回首页'
  },
  videoCourse: {
    content: [
      {
        name: '视频教程',
        sub: '快速上手以及详细教学',
        items: [
          {
            code: 'img_guide01@2x',
            name: '快速上手指南'
          },
          {
            code: 'img_guide02@2x',
            name: '完整版操作指南'
          }
        ]
      },
      {
        name: '分段教学',
        sub: '功能模块拆解分段学习',
        items: [
          {
            code: 'img_01getready@2x',
            name: '使用前准备'
          },
          {
            code: 'img_03shotstep@2x',
            name: '拍摄流程'
          },
          {
            code: 'img_08shotmode@2x',
            name: '拍摄方式'
          },
          {
            code: 'img_05point@2x',
            name: '点位调整功能'
          },
          {
            code: 'img_06video@2x',
            name: '球幕视频功能'
          },
          {
            code: 'img_02editmb@2x',
            name: '编辑模型-手机APP端模型编辑'
          },
          {
            code: 'img_04editpc@2x',
            name: '编辑模型-PC端模型编辑'
          },
          {
            code: 'img_07share@2x',
            name: '上传分享'
          }
        ]
      }
    ]
  },
  home,
  binocular,
  eight,
  about,
  coreTech,
  purchase,
  purchasetow,
  purchasezhijia,
  manage,
  agent,
  toast
}



// WEBPACK FOOTER //
// ./src/store/language/home_cn.js